/* eslint new-cap: ["error", { "capIsNew": false }]*/
import {fromJS, Map} from 'immutable';
import {putError} from '../store/error.store';
import {RestAPI} from '../util/net';
import {replace} from 'react-router-redux';
import {clearAllStatuses} from '../store/storeForStoringStatusOfStores.store';
import {clearQueue, MFA_CODES} from '../util/util.jsx';
import store from './store';
import {validateComplex} from '../component/auth/RoleConfigFilter.jsx';
import {closeWS} from './websocket/dispatcher';

const DEFAULT_STORE_NODE_VALUE = Map();

const loginAttemptStarted = (state) =>
  state.set('state', 'LOGIN_ATTEMPT').delete('user');

const loginFailed = (state) =>
  state.set('state', 'LOGIN_FAILED').delete('user');

const loginSuccessful = (state, action) => {
  clearQueue();
  const result = state
    .set('state', 'LOGGED_IN')
    .set('user', action.user)
    .set('csrf', action.csrf)
    .set('firstName', action.firstName)
    .set('lastName', action.lastName)
    .set('id', action.userId)
    .set('roles', action.roles)
    .set('modules', action.modules)
    .set('version', action.version)
    .set('origin', action.origin)
    .set('applicationRegion', action.applicationRegion)
    .set('roleConfigs', fromJS(action.roleConfigs))
    .set('reportConfigs', fromJS(action.reportConfigs))
    .set('customReportOrigins', fromJS(action.customReportOrigins))
    .set('supplyDemandResponsibles', fromJS(action.supplyDemandResponsibles));
  return result;
};
const logout = (state) => {
  const cleared = state.clear();
  closeWS();
  return cleared;
};

export const sessionReducer = (state = DEFAULT_STORE_NODE_VALUE, action) => {
  switch (action.type) {
    case 'LOGIN_ATTEMPT_STARTED':
      return loginAttemptStarted(state, action);
    case 'LOGIN_FAILED':
      return loginFailed(state, action);
    case 'LOGIN_SUCCESSFUL' :
      return loginSuccessful(state, action);
    case 'LOGOUT' :
      return logout(state, action);
    case 'RETRIEVE_BLOCK_SUCCESSFUL':
      return state.set('blockTime',
        fromJS({ remaining: action.block.remaining || 0, total: action.block.total || 0 }));
    case 'RETRIEVE_BLOCK_FAILED':
      return state.set('blockTimeFailureFlag', true);
    case 'MFA_CODE_REQUIRED':
      return state.set('mfaCodeRequired', true)
    default:
      return state;
  }
};
function logoutFunc() {
  return RestAPI.post('/logout');
}
function logoutDispatch(dispatch) {
  dispatch({ type: 'LOGOUT' });
  dispatch({ type: 'CLEAR_STATS' });
}

export const retrieveBlockTime = (dispatch) => {
  dispatch({ type: 'RETRIEVE_BLOCK_STARTED' });
  return RestAPI.get('/auth/blockstate')
    .then((data) => {
      dispatch({ type: 'RETRIEVE_BLOCK_SUCCESSFUL', block: data });
      return true;
    },
    (data) => {
      dispatch({ type: 'RETRIEVE_BLOCK_FAILED' });
      putError(dispatch, data);
      return true;
    }
    );
};

export const tryToLogout = (dispatch, sendStats = true) => {
  let request;
  if (sendStats) {
    request = RestAPI.post('/usermetrics', store.getState().get('usage').toJS())
      .catch(logoutFunc()).then(logoutFunc(), logoutFunc())
      .then(() => true);
  } else {
    request = RestAPI.post('/logout').then(() => true);
  }
  request.then(logoutDispatch(dispatch), logoutDispatch(dispatch)).catch(logoutDispatch(dispatch));
  request.then(retrieveBlockTime(dispatch)).catch(retrieveBlockTime(dispatch));
  return request;
};

export const resolveInitialPage = (dispatch) => {
  if (!validateComplex(['ROLE_ADMIN', 'ROLE_OPERATIONS', 'ROLE_OPERATIONS_HEAD',
    'ROLE_OPERATIONS_LIMITED', 'ROLE_TRADER_HEAD', 'ROLE_TRADER'],
  ['allDeals#1', 'myDeals#1', 'viewDealsByRegion'])) {
    if (validateComplex(['ROLE_CHARTERING'], ['allTransports#1', 'myTransports#1'])) {
      dispatch(replace('/deals/transport'));
      return true;
    } else if (validateComplex(['ROLE_FINANCE'],
      ['financesViewEditDelete', 'myPaymentsView'])) {
      dispatch(replace('/deals/outpayments'));
      return true;
    }
  }
  return false;
};

export const tryToLogin = (dispatch, username, pass, mfaCode, nextPathName) => {
  dispatch({type: 'LOGIN_ATTEMPT_STARTED'});
  return RestAPI.post('/login', {username, password: pass, mfaCode})
    .then((response) => {
        clearAllStatuses(dispatch);
        dispatch({type: 'LOGIN_SUCCESSFUL', user: username, ...response});
        if (nextPathName) {
          dispatch(replace(nextPathName));
        } else {
          dispatch(replace('/'));
          resolveInitialPage(dispatch);
        }
        return true;
      },
      (data) => {
        if (MFA_CODES.includes(data.code)) {
          dispatch({type: 'MFA_CODE_REQUIRED'});
          putError(dispatch, data);
          return true;
        }
        dispatch({type: 'LOGIN_FAILED'});
        putError(dispatch, data);
        return true;
      }
    );
}
